
/**
 * Returns the true/false for the given element
 * if there's a match for the given class on the parent elements
 * @param {DOMNode} el 
 * @param {String} className 
 */
export function isParent(el, className) {
  let node = el;
  while (node.parentNode) {
    node = node.parentNode;
    if (node.classList && node.classList.contains(className)) {
      return true;
    }
  }

  return false;
}
